import React, { useState } from 'react'
import FilterNoneIcon from '@material-ui/icons/FilterNone'
import Tooltip from '@material-ui/core/Tooltip'

import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'

const DEFAULT_COPY_TEXT = 'Copy to clipboard'
const COPIED_TEXT = 'Copied!'

export const CodeBlock = ({ text }) => {
  const [tooltipText, setTooltipText] = useState(DEFAULT_COPY_TEXT)
  const [copyToClipboard] = useCopyToClipboard()

  return (
    <code className='code-block flex items-center gap-2'>
      <span>
        {text}
      </span>
      <Tooltip enterNextDelay={100}
        title={tooltipText} onOpen={() => setTooltipText(DEFAULT_COPY_TEXT)}>
        <FilterNoneIcon
          style={{ cursor: 'pointer' }}
          onClick={async () => {
            setTooltipText(COPIED_TEXT)
            copyToClipboard(text)
          }}
        />
      </Tooltip>
    </code>
  )
}
